import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DesktopNav from './sub/DesktopNav';
import MobileNav from './sub/MobileNav';
import { ChevronsLeft } from 'lucide-react';
import { usePublic } from '../../../../context/PublicContext';
import { env } from '../../../../config/env';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings, isLoadingSettings } = usePublic();

  // --- Gestion du scroll pour cacher/afficher le header ---
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Cache le header uniquement si on descend et qu'on a dépassé un petit seuil (80px)
      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        setIsHeaderVisible(false);
      } else {
        setIsHeaderVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // --------------------------------------------------------

  const goBack = () => {
    navigate(-1);
  };

  const showBackButton = location.pathname !== '/' && window.history.length > 1;

  const logoUrl = settings?.logo
    ? `${env.IMAGE_BASE_URL_SANS_STORAGE}${settings.logo}`
    : "/assets/logo/logoPsaumesetplantes-removebg-preview.png";
  const legalName = settings?.legal_name || "PSAUMES & PLANTES";

  if (isLoadingSettings) {
    return (
      <header className="bg-green-800 text-white shadow-lg sticky top-0 z-50 transition-transform duration-300">
        <div className="max-w-7xl mx-auto p-2 flex items-center justify-between md:gap-24">
          <div className="flex items-center justify-center gap-2 md:gap-1">
            <div className="h-12 w-12 bg-white/20 rounded-full animate-pulse"></div>
            <div className="h-6 w-32 bg-white/20 rounded animate-pulse"></div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header
      className={`bg-green-800 text-white shadow-lg sticky top-0 z-50 transition-transform duration-300 ${
        isHeaderVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto p-2 flex items-center justify-between md:gap-24">
        <div className="flex items-center justify-center gap-2 md:gap-1">
          <img
            src={logoUrl}
            alt={legalName}
            className="h-12 w-auto bg-white p-1 rounded-full object-contain cursor-pointer"
            onClick={() => window.location.href = '/'}
          />
          <span className="text-[16px] md:text-2xl font-bold tracking-tight md:whitespace-nowrap">
            {legalName}
          </span>
        </div>

        <DesktopNav />
        <MobileNav />

        {showBackButton && (
          <button
            onClick={goBack}
            className="md:hidden fixed top-24 left-1 md:left-24 bg-primary text-white md:p-3 p-2 rounded-full shadow-lg hover:scale-110 transition-all duration-300 z-40 md:top-14"
            aria-label="Retour à la page précédente"
          >
            <ChevronsLeft size={24} />
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;